import { FC, memo } from 'react';
import Script from 'next/script';

/**
 * PageViewAnalyticsコンポーネントのProps
 */
interface Props {
  /** ページ名 */
  pageName: string;
  /** チャンネル（任意） */
  channel?: string;
}

/**
 * PageViewAnalyticsコンポーネント
 * ページのビューアナリティクス用スクリプトを挿入
 * @param {Props} props - コンポーネントのプロパティ
 * @returns {JSX.Element} PageViewAnalyticsのJSX要素
 */
export const PageViewAnalytics: FC<Props> = memo(({ pageName, channel }) => {
  return (
    <Script>
      {`// AA
      if (!window.sc){
          window.sc = {};
      }
      sc.pageName="${pageName}"
      sc.channel="${channel ?? pageName}"
      // GA
      window.dataLayer = window.dataLayer || [];
      dataLayer.push({
      'PageName': '${pageName}',
      'Channel': '${channel ?? pageName}'
      }); `}
    </Script>
  );
});

PageViewAnalytics.displayName = 'PageViewAnalytics';
